// Share one opaque in-memory identity across widget mounts. Never put card
// credentials in SWR keys, request URLs, or a persisted balance cache.
export function createSnapperCacheKey(createToken = () => crypto.randomUUID()) {
  let previousNumber;
  let previousCvv;
  let key = null;
  return (number, cvv) => {
    const normalizedNumber = String(number || "").replace(/\D/g, "");
    if (!normalizedNumber || !cvv) return null;
    if (normalizedNumber !== previousNumber || cvv !== previousCvv) {
      previousNumber = normalizedNumber;
      previousCvv = cvv;
      key = `snapper-card-${createToken()}`;
    }
    return key;
  };
}

export const getSnapperCacheKey = createSnapperCacheKey();
